import { Component, input, output } from '@angular/core';
import { PalantirIconComponent } from '../../../icon/icon.component';
import { PalantirTooltipModule } from '../../../tooltip/tooltip.module';

@Component({
  selector: 'fx-dynamic-tabular-table-row-actions',
  standalone: true,
  imports: [PalantirIconComponent, PalantirTooltipModule],
  templateUrl: './dynamic-tabular-table-row-actions.component.html',
})
export class FxDynamicTabularTableRowActionsComponent {
  public readonly rowIndex = input.required<number>();

  public readonly readonly = input<boolean>(false);

  public readonly canRemove = input<boolean>(false);

  public readonly odd = input<boolean>(false);

  public readonly remove = output();
}
